/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OrganisationResponse
 */
export interface OrganisationResponse {
    /**
     *
     * @type {string}
     * @memberof OrganisationResponse
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof OrganisationResponse
     */
    fullName?: string;
    /**
     * Name of this org in JIRA service desk. If null, users in this org can't create maintenance tickets even if they hold ticketing_create.
     * @type {string}
     * @memberof OrganisationResponse
     */
    externalMaintenanceTicketingName?: string;
    /**
     * The max number of devices that users in this org can create.
     * @type {number}
     * @memberof OrganisationResponse
     */
    deviceProvisioningLimit?: number;
    /**
     * The parent (partner) organisation managing this org, if any.
     * @type {string}
     * @memberof OrganisationResponse
     */
    parentOrganisationId?: string;
}

/**
 * Check if a given object implements the OrganisationResponse interface.
 */
export function instanceOfOrganisationResponse(
    value: object,
): value is OrganisationResponse {
    return true;
}

export function OrganisationResponseFromJSON(json: any): OrganisationResponse {
    return OrganisationResponseFromJSONTyped(json, false);
}

export function OrganisationResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrganisationResponse {
    if (json == null) {
        return json;
    }
    return {
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        fullName: json["fullName"] == null ? undefined : json["fullName"],
        externalMaintenanceTicketingName:
            json["externalMaintenanceTicketingName"] == null
                ? undefined
                : json["externalMaintenanceTicketingName"],
        deviceProvisioningLimit:
            json["deviceProvisioningLimit"] == null
                ? undefined
                : json["deviceProvisioningLimit"],
        parentOrganisationId:
            json["parentOrganisationId"] == null
                ? undefined
                : json["parentOrganisationId"],
    };
}

export function OrganisationResponseToJSON(
    value?: OrganisationResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        organisationId: value["organisationId"],
        fullName: value["fullName"],
        externalMaintenanceTicketingName:
            value["externalMaintenanceTicketingName"],
        deviceProvisioningLimit: value["deviceProvisioningLimit"],
        parentOrganisationId: value["parentOrganisationId"],
    };
}
